import { Box, Button, FormControl, TextField } from "@mui/material";
import UseLogin from "./UseLogin";


const Login = () => {
    const {username, setUsername, pwd, setPwd, errMsg, userRef, errRef, handleSubmit} = UseLogin();

    return(
        <Box alignItems={"center"}>
            <FormControl>
                <form onSubmit={handleSubmit}>
                        <TextField
                            hiddenLabel
                            required
                            autoComplete="off"
                            id="filled-hidden-label-small"
                            placeholder="email"
                            variant="filled"
                            ref={userRef}
                            onChange={(e) => setUsername(e.target.value)}
                            value={username}
                        />
                        <TextField
                            hiddenLabel
                            required
                            autoComplete="off"
                            id="filled-hidden-label-normal"
                            placeholder="password"
                            variant="filled"
                            type="password"
                            onChange={(e) => setPwd(e.target.value)}
                            value={pwd}
                        />
                        <Button type="submit" variant="contained">Login</Button>
                </form>
            </FormControl>
            <p ref={errRef} aria-live="assertive">{errMsg}</p>
        </Box>
    )
}

export default Login;